document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById('myModal');
    const acceptButton = document.getElementById('acceptButton');
    const CACHE_KEY = 'rc_popup_accepted';
    const CACHE_DURATION = 1440 * 60 * 1000;
    const checkbox = document.getElementById("termsCheckbox");

    // Function to cache the user's acceptance
    function cacheAcceptance() {
        const currentTime = new Date().getTime();
        const expirationTime = new Date(currentTime + CACHE_DURATION);

        document.cookie = `${CACHE_KEY}=${currentTime}; expires=${expirationTime.toUTCString()}; path=/`;
    }

    function shouldShowPopup() {
        // Check if utm_source matches the counterfeit verify page pattern
        const urlParams = new URLSearchParams(window.location.search);
        const utmSource = urlParams.get('utm_source');

        if (utmSource && /^[A-Z]{2}_counterfeit_verify_page$/.test(utmSource)) {
            return false; // Never show popup for counterfeit verify pages
        }

        const cookies = document.cookie.split(';');

        for (let cookie of cookies) {
            const [name, value] = cookie.trim().split('=');

            if (name === CACHE_KEY) {
                try {
                    const timestamp = parseInt(value);
                    const currentTime = new Date().getTime();

                    // Check if cache duration has passed
                    if (currentTime - timestamp > CACHE_DURATION) {
                        // Cookie expired, remove it
                        document.cookie = `${CACHE_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
                        return true; // Cache expired, show popup
                    }

                    return false; // Cache valid, don't show popup
                } catch (error) {
                    // If there's an error parsing, remove the cookie and show popup
                    document.cookie = `${CACHE_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
                    return true;
                }
            }
        }

        return true; // No cookie found, show popup
    }

    // Function to hide popup with animation
    function hidePopup() {
        popup.classList.add('hidden');
        setTimeout(() => {
            popup.style.display = 'none';
        }, 300);
    }

    // Event listener for the "Yes" button
    acceptButton.addEventListener('click', function () {
        cacheAcceptance();
        hidePopup();
        console.log('User accepted the popup');
    });

    // Show popup if needed
    if (shouldShowPopup()) {
        popup.style.display = 'flex';
        popup.classList.remove('hidden');

        checkbox.addEventListener('change', function () {
            acceptButton.disabled = !checkbox.checked;
            console.log('check-check');
        });
    } else {
        popup.style.display = 'none';

        checkbox.removeEventListener('change');
    }
});
